import { html } from 'lit';
import { AlertTriangle } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-alert-triangle')
export class PdsIconAlertTriangle extends PdsIcon {
  @state()
  icon = AlertTriangle;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
